import React, { Fragment } from 'react';
import {
  userPreferenceUnitState,
  userPreferencesSelectedSdpState,
} from '../../../../atoms/userPreferencesAtom/userPreferencesAtom';

import { BudgetReferenceValueResponse } from '../../../../models/BudgetReferenceValueResponse';
import { ConsumptionUnitEnum } from '../../../../enum/ConsumptionUnitEnum';
import { NumberUtils } from '../../../../common/numberUtils';
import { SDPTariffChoiceEnum } from '../../../../enum/SDPTariffChoiceEnum';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';

export interface MeterForecastInformationProps {
  budgetReference?: BudgetReferenceValueResponse;
  hasCaption?: boolean;
}
export default function MeterForecastInformation({
  budgetReference,
  hasCaption = true,
}: MeterForecastInformationProps) {
  const { t } = useTranslation();
  const unit = useRecoilValue(userPreferenceUnitState);
  const selectedSdp = useRecoilValue(userPreferencesSelectedSdpState);

  return (
    <Fragment>
      <div className="meter-forecast__wizard__step">
        <h1 className="meter-forecast__wizard__step__title">
          {t('overview.meter.detail.forecast.wizard.step1.title')}
        </h1>
        <p className="meter-forecast__wizard__step__description">
          {t('overview.meter.detail.forecast.wizard.step1.description')}
        </p>
        <div className="meter-forecast__card">
          {selectedSdp?.tariffChoice !== SDPTariffChoiceEnum.NONE &&
            budgetReference?.referenceAmount && (
              <div className="meter-forecast__card__item">
                <div className="meter-forecast__card__item__value annual-cost">
                  {NumberUtils.parse(budgetReference?.referenceAmount)}&nbsp;
                  <span className="meter-forecast__card__item__currency">€</span>
                </div>
                <div className="meter-forecast__card__item__label">
                  {t('overview.meter.detail.forecast.wizard.step1.annual.coast')}
                </div>
              </div>
            )}
          {budgetReference?.referenceConsumption && (
            <div className="meter-forecast__card__item">
              <div className="meter-forecast__card__item__value annual-consumption">
                {NumberUtils.parse(budgetReference?.referenceConsumption)}&nbsp;
                <span className="meter-forecast__card__item__currency">
                  {ConsumptionUnitEnum.getSymbol(ConsumptionUnitEnum.KWH)}
                </span>
              </div>
              <div className="meter-forecast__card__item__label">
                {t('overview.meter.detail.forecast.wizard.step1.annual.consumption')}
              </div>
            </div>
          )}
        </div>
        {hasCaption &&
          budgetReference?.referenceAmount !== null &&
          budgetReference?.referenceConsumption !== null && (
            <p className="meter-forecast__advance">
              {t('overview.meter.detail.forecast.wizard.step1.caption')}
              &nbsp;
              <span className="meter-forecast__advance__value">
                {NumberUtils.parse(
                  selectedSdp?.tariffChoice === SDPTariffChoiceEnum.NONE
                    ? budgetReference!.referenceConsumption! / 12
                    : budgetReference!.referenceAmount! / 12
                )}
                {ConsumptionUnitEnum.getSymbol(unit)}
              </span>
            </p>
          )}
      </div>
    </Fragment>
  );
}
